import { action, computed, observable } from 'mobx';
import Store from './Store';

class StoresCollection {
  @observable stores: Store[];

  @observable selectedStore: Store;

  @action
  setStores = (stores: Store[]): void => {
    this.stores = stores;
  };

  @action
  setSelectedStore = (store: Store): void => {
    this.selectedStore = store;
  };

  @computed
  get storesSortedByDistance(): Store[] {
    return this.stores?.sort((a, b) => a.distance - b.distance);
  }

  getSelectedStore = (storeId: string): Store => (
    this.stores?.find(({ doorId }) => doorId === storeId));
}

export default StoresCollection;
